import CacheClearAll from "../usecases/CacheClearAll";
import Pages from "../pages/Pages";

// const api_url = 'http://saframanager.com:3001'
// const api_url = 'http://192.168.25.102:3001'
// const api_url = "https://api.saframanager.com"
// const api_url = "http://localhost:3001"
const api_url = process.env.REACT_APP_API_URL

/*
The APIManager is responsible to fetch with the API
*/

let handlingUnauthorized = false;

const AUTH_ROUTES_SKIP_LOGOUT = ['/login', '/auth'];

const createHttpError = (res) => {
    const error = new Error(`HTTP ${res.status}`);
    error.status = res.status;
    error.response = res;
    return error;
};

const handleUnauthorized = (to) => {
    if (AUTH_ROUTES_SKIP_LOGOUT.includes(to) || handlingUnauthorized) return;

    handlingUnauthorized = true;
    CacheClearAll()
        .catch(() => {})
        .finally(() => {
            if (!window.location.pathname.startsWith(Pages.routes.Login)) {
                window.location.assign(Pages.routes.Login);
            }
        });
};

const APIManager = {

    /*
        send function - make a fetch to a route of the api
        params:
            - to: String value of the route (e.g: "/login")            
            - method: String value for the request method (e.g: "GET", "POST", "PUT"...)
            - header: Object value for the headers
            - body: Object value for the body
            - res_expected: Number, integer, for the expected response, if null it will expect 200
        returns: 
            - A promisse that can be resolve if the request is performed with success, 
            or reject if there is an error or the response status is different from the res_expected
    */
    send: (to, method, header, body, res_expected) => {
        return new Promise((resolve, reject) => {
            let send_headers = {
                ...header,
                'Content-Type': 'application/json'
            }
            let send_body = {
                ...body
            }

            fetch(api_url+to,{
                method: method,
                headers: send_headers,
                body: (method !== "GET") ? JSON.stringify(send_body) : null,
            }).then(res =>{
                if(res.status === (res_expected ? res_expected : 200)){
                    resolve(res)
                }else{
                    if (res.status === 401) {
                        handleUnauthorized(to);
                    }
                    reject(createHttpError(res))
                }
            }).catch(err => {
                reject(err)
            })
        })
    }

}

export default APIManager;
